var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182.99 179.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a8c0;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 91.5,
    cy: 90,
    rx: 91.5,
    ry: 90
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.53,51.89H95.07s24.13,9,22.13,32.34c0,0-27.59,2.66-22.13,32.33v1.67H80.42L55.86,135.56l5.67-17.33H45.2s-25.34-5.67-25.67-38.67C19.53,79.56,24.2,54.89,43.53,51.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.2,84.28a5.67,5.67,0,1,1-5.67-5.72A5.7,5.7,0,0,1,50.2,84.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.09,84.28a5.67,5.67,0,1,1-5.67-5.72A5.7,5.7,0,0,1,74.09,84.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.42,84.28a5.67,5.67,0,1,1-5.66-5.72A5.69,5.69,0,0,1,98.42,84.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.19,88h34.34s15.66,2.24,15.33,23.57c0,0,1,10.67-13.33,18H134.19L138,141.23l-17.85-11.67h-4.88s-14.78.33-15.45-21.67C99.86,107.89,98.86,93.1,113.19,88Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.3259216f91aa0612fa5dcdb0c7dcdf8a.svg";
export { ForwardRef as ReactComponent };